import React from 'react';
import Carousel from 'react-bootstrap/Carousel';

// Import your images
import image1 from '../../asserts/Speed Academy Slide with logo.jpg';
import image2 from '../../asserts/Speed Academy Slide - 2.png';
import image3 from '../../asserts/Speed Academy Slide – 3.png';
import image4 from '../../asserts/Speed Academy Slide – 4.png';
import image5 from '../../asserts/Speed Academy Slide – 5.png';

function UncontrolledExample() {
  return (
    <Carousel>
      <Carousel.Item>
        <img className="d-block w-100" src={image1} alt="First slide" />
       
      </Carousel.Item>
      <Carousel.Item>
        <img className="d-block w-100" src={image2} alt="Second slide" />
        
      </Carousel.Item>
      <Carousel.Item>
        <img className="d-block w-100" src={image3} alt="Third slide" />
       
      </Carousel.Item>
      <Carousel.Item>
        <img className="d-block w-100" src={image4} alt="Fourth slide" />
        
      </Carousel.Item>
      <Carousel.Item>
        <img className="d-block w-100" src={image5} alt="Fifth slide" />
        
      </Carousel.Item>
    </Carousel>
  );
}

export default UncontrolledExample;
